import React from 'react';

const MemberIcon = () => (
  <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18.6654 31.3334C14.0695 31.3334 10.332 27.5959 10.332 23C10.332 18.4042 14.0695 14.6667 18.6654 14.6667C23.2612 14.6667 26.9987 18.4042 26.9987 23C26.9987 27.5959 23.2612 31.3334 18.6654 31.3334ZM18.6654 18.8334C16.3674 18.8334 14.4987 20.7 14.4987 23C14.4987 25.2979 16.3674 27.1667 18.6654 27.1667C20.9633 27.1667 22.832 25.2979 22.832 23C22.832 20.7 20.9633 18.8334 18.6654 18.8334Z'
      fill='#062471'
    />
    <path
      d='M34.3333 48H3V45.9167C3 38.5563 8.85417 33.4167 18.6667 33.4167C28.4792 33.4167 34.3333 38.5563 34.3333 45.9167V48ZM7.49792 43.8334H29.8375C28.5917 40.0667 24.9354 37.5834 18.6688 37.5834C12.4021 37.5834 8.74375 40.0667 7.49792 43.8334Z'
      fill='#062471'
    />
    <path
      d='M34.5713 2.32094C34.9066 1.48286 36.0931 1.48298 36.4282 2.32113L38.8194 8.30048C38.9713 8.68018 39.339 8.92917 39.7479 8.92917H45.265C46.1972 8.92917 46.6224 10.092 45.9101 10.6933L40.8439 14.9698C40.5063 15.2548 40.3957 15.7275 40.5718 16.1327L43.082 21.9062C43.4789 22.8191 42.4436 23.6881 41.6133 23.139L36.0516 19.4606C35.7171 19.2394 35.2829 19.2394 34.9484 19.4606L29.3852 23.139C28.5549 23.6881 27.5196 22.8189 27.9167 21.906L30.428 16.1328C30.6043 15.7276 30.4937 15.2547 30.156 14.9697L25.0899 10.6933C24.3776 10.092 24.8028 8.92917 25.735 8.92917H31.2501C31.659 8.92917 32.0267 8.68027 32.1786 8.30067L34.5713 2.32094Z'
      fill='#062471'
    />
  </svg>
);

export default MemberIcon;
